import React, { PureComponent } from 'react';
import { NormalizedSeries } from 'types';
// Components
import ChartSeries from './chart-series';
import { NAVIGATOR_HEIGHT } from './utils';
import ChartNavigatorHandle from './chart-navigator-handle';
import styles from './chart.scss';
import ChartNavigatorRange from './chart-navigator-range';
import Mouse from 'core/mouse';

const MAX_POINTS = 100;
interface ChartNavigatorProps {
  width: number;
  series: NormalizedSeries[];
  onRange: (range: [number, number]) => void;
}
export default class ChartNavigator extends PureComponent<ChartNavigatorProps> {
  state = {
    dragging: false,
    tmpRange: null
  };

  rect;

  getOffset(pageX): number {
    return (pageX - this.rect.left) / this.rect.width;
  }

  handleMoveStart = offset => {
    let [, end] = this.props.range;
    if (offset > end) end = Math.min(1, offset + 0.01);
    this.props.onRange([offset, end]);
  };

  handleMoveEnd = offset => {
    let [start] = this.props.range;
    if (offset < start) start = Math.max(0, offset - 0.01);
    this.props.onRange([start, offset]);
  };

  handleClick = (e: MouseEvent) => {
    this.rect = e.currentTarget.getBoundingClientRect();
    Mouse.on('mousemove', this.handleMove);
    Mouse.on('mouseup', this.handleMouseUp);
    this.handleMove(e);
  };

  handleMove = (e: MouseEvent) => {
    const percent = (e.pageX - this.rect.left) / this.rect.width;
    let [start, end] = this.props.range;
    const dOffset = Math.min(1 - end, Math.max(-start, percent - start));

    this.props.onRange([start + dOffset, end + dOffset]);
  };

  handleCreateStart = (e: MouseEvent) => {
    this.rect = e.currentTarget.getBoundingClientRect();
    Mouse.on('mousemove', this.handleCreateMove);
    Mouse.on('mouseup', this.handleCreateEnd);
  };

  handleCreateMove = (e: MouseEvent) => {
    const { dragging } = this.state;
    if (!dragging && Mouse.getDownDistX() < 5) return;
    const start = Math.min(Mouse.pageDownX, e.pageX);
    const end = Math.max(Mouse.pageDownY, e.pageX);
    this.setState({
      dragging: true,
      tmpRange: [this.getOffset(start), this.getOffset(end)]
    });
  };

  handleCreateEnd = () => {
    Mouse.off('mousemove', this.handleCreateMove);
    Mouse.off('mouseup', this.handleCreateEnd);
    if (this.state.dragging) {
      this.props.onRange(this.state.tmpRange);
      this.setState({ tmpRange: null, dragging: false });
    }
  };

  handleMouseUp = () => {
    Mouse.off('mousemove', this.handleMove);
    Mouse.off('mouseup', this.handleMouseUp);
  };

  render() {
    const { hideSeries, range, width, series, onRange } = this.props;
    return (
      <div className={styles.navigator}>
        <svg height={NAVIGATOR_HEIGHT} width={width} onMouseDown={this.handleCreateStart}>
          {series.map(
            s =>
              (!hideSeries || !hideSeries[s.id]) && (
                <ChartSeries
                  key={s.id}
                  maxPoints={MAX_POINTS}
                  hideLines
                  hideTooltip
                  series={s}
                  height={NAVIGATOR_HEIGHT}
                  width={width}
                />
              )
          )}

          <ChartNavigatorRange
            range={this.state.tmpRange || range}
            width={width}
            onChange={onRange}
          />
          {/* <ChartNavigatorHandle offset={range[0]} width={width} onChange={this.handleMoveStart} />
          <ChartNavigatorHandle offset={range[1]} end width={width} onChange={this.handleMoveEnd} /> */}
        </svg>
      </div>
    );
  }
}
